import React from 'react';
import { motion } from 'framer-motion';

const GlassCard = ({ icon: Icon, title, subtitle, className = '', delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, delay }}
      className={`bg-white/10 dark:bg-black/20 backdrop-blur-md border border-white/20 dark:border-[var(--accent-primary)]/20 rounded-xl p-4 shadow-lg ${className}`}
    >
      {Icon && <Icon className="w-5 h-5 text-[var(--accent-primary)] mb-2" />}
      <p className="text-sm font-semibold text-[var(--text-primary)] mb-1">{title}</p>
      <p className="text-xs text-[var(--text-muted)]">{subtitle}</p>
    </motion.div>
  );
};

export default GlassCard;